import React from "react";
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';
import { useGAEvent, getSmoothBrushState } from 'components/AppService/GAService';
import { ReaderToolType } from 'constants/ReaderTools';
import { withTranslation } from 'react-i18next';

export const active = { backgroundColor: "#aaa", color: "#fff" };

const PanelState = {
    None: 'None',
    Pen: 'Pen',
    Highlighter: 'Highlighter',
    LaserPen: 'LaserPen',
    Shape: 'Shape',
    Line: 'Line',
    Expression: 'Expression',
    MeasureTools: 'MeasureTools'
};

// 這些工具第一次點擊只切換工具，已是目前工具時再點一次才開設定面板
const PANEL_ON_SECOND_CLICK_TOOLS = [
    ReaderToolType.Painting,
    ReaderToolType.Highlighter,
    ReaderToolType.LaserPen
];

let updateState;
let neglect = false;
const ActivatableReaderToolComponent = ({ t, currentReaderToolType, type, additionalClickHandler, nowPanelState }) => {
    const { gaEvent } = useGAEvent();
    const doubleClickToolPanel = {
        Painting: ReaderToolType.Painting,
        Highlighter: ReaderToolType.Painting
    }

    if (type === ReaderToolType.Select) {
        if (updateState !== PanelState.None && updateState !== nowPanelState) {
            neglect = true;
        } else {
            neglect = false;
        }
        if (nowPanelState) {
            updateState = nowPanelState
        }
    }

    const tool = toolsEventMap[type];
    return (
        <Button
            key={type}
            onClick={(e) => {
                if (tool.ga) {
                    // 畫筆／螢光筆額外帶上畫筆流暢模式狀態，供交叉分析「開啟流暢模式的人是否較常用畫筆」。
                    // 事件名（Reader）與 tap_event（工具列_畫筆／工具列_螢光筆）都不變，只多一個 smooth_brush 參數。
                    const isBrushTool =
                        type === ReaderToolType.Painting || type === ReaderToolType.Highlighter;
                    gaEvent(
                        isBrushTool
                            ? { module: 'Reader', tapEvent: tool.ga, smoothBrush: getSmoothBrushState() }
                            : tool.ga
                    );
                }
                tool.clickHandler();
                if (PANEL_ON_SECOND_CLICK_TOOLS.includes(type)) {
                    if (currentReaderToolType === type && !neglect) {
                        additionalClickHandler && additionalClickHandler();
                    }
                }else{
                    additionalClickHandler && additionalClickHandler();
                }
            }}
            title={`${t(tool.title)}${PANEL_ON_SECOND_CLICK_TOOLS.includes(type) ? "(雙擊可開啟設定面板)" : ""}`} // hover tooltip
            inlineStyle={currentReaderToolType === type && active}
        >
            <Icon name={tool.icon} />
            <div className={styles.text}>{t(tool.title)}</div>
        </Button>
    );
};

export default withTranslation()(ActivatableReaderToolComponent);
